<div class="right-menu" (mouseover)="placeTooltip($event)">
  <div class="top-buttons">
    <button
      type="button"
      class="icon-button"
      [class.active]="store.activeTool() === 'ruler'"
      (click)="store.toggleTool('ruler')">
      <img src="assets/icon/Ruler.svg" alt="" />
      <div class="icon-button__label">{{ 'GLOBAL.RULER' | translate }}</div>
      <div class="tooltip-custom">{{ 'GLOBAL.MEASURE_TOOL' | translate }}</div>
    </button>
    <div class="button-separator"></div>
    <button
      type="button"
      class="icon-button"
      [class.active]="store.activeTool() === 'polygon'"
      (click)="store.toggleTool('polygon')">
      <img src="assets/icon/Polygon_right.svg" alt="" />
      <div class="icon-button__label">{{ 'POLYGON.POLYGON' | translate }}</div>
      <div class="tooltip-custom">{{ 'GLOBAL.POLYGON_CREATE_TOOL' | translate }}</div>
    </button>
    <div class="button-separator"></div>
    <button
      type="button"
      class="icon-button"
      [class.active]="store.activeTool() === 'zone'"
      (click)="store.toggleTool('zone')">
      <img src="assets/icon/Polygon_right.svg" alt="" />
      <div class="icon-button__label">{{ 'ZOI.ZONE' | translate }}</div>
      <div class="tooltip-custom">{{ 'ZOI.CREATE_TOOL' | translate }}</div>
    </button>
  </div>

  <div class="bottom-buttons">
    @for (button of panelButtons; track button.panel) {
      <button
        type="button"
        class="icon-button-bottom"
        [class.active]="store.activePanel() === button.panel"
        [disabled]="!isEnabled(button)"
        (click)="store.togglePanel(button.panel)">
        <img [src]="button.icon" alt="" />
        <div class="tooltip-custom">{{ button.tooltip | translate }}</div>
      </button>
    }
  </div>
</div>
